import { render } from "./OrgManagementListing.vue?vue&type=template&id=28bfa210&scoped=true"
import script from "./OrgManagementListing.vue?vue&type=script&lang=js"
export * from "./OrgManagementListing.vue?vue&type=script&lang=js"

import "./OrgManagementListing.vue?vue&type=style&index=0&id=28bfa210&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bfa210"]])

export default __exports__